import axios from "axios";
import { getMunicipalityName, hasMunicipalityName } from "../../data/kommuner";

const api = axios.create({
  baseURL: process.env.REACT_APP_WP_PUBLIC_API_URL
});

export async function getMunicipalityData(
  municipality1 = null,
  municipality2 = null,
  municipalities
) {
  let response = await api.get(
    "api/Municipality?id=" + municipality1 + "&id=" + municipality2
  );
  return await asyncGetMunicipalityData(response.data, municipalities);
}

async function asyncGetMunicipalityData(response_data, municipalities) {
  var data = [];
  data.push({
    population: [],
    populationChange: [],
    gender: [],
    genderAge: [],
    birthplace: [],
    populationLocation: [],
    landUse: [],
    income: [],
    emplomentExtent: [],
    accommodation: [],
    livingCondition: [],
    taxRate: [],
    election: []
  });
  //Removes null values
  var filtered = municipalities.filter(Boolean);

  //Loop structure data
  filtered.forEach(async (muni, idx) => {
    let municipality_data = await response_data;
    data[0].population.push(...municipality_data[idx].population);
    data[0].populationChange.push(...municipality_data[idx].populationChange);
    data[0].gender.push(...municipality_data[idx].gender);
    data[0].genderAge.push(...municipality_data[idx].genderAge);
    data[0].birthplace.push(...municipality_data[idx].birthplace);
    data[0].populationLocation.push(
      ...municipality_data[idx].populationLocation
    );
    data[0].landUse.push(...municipality_data[idx].landUse);
    data[0].income.push(...municipality_data[idx].income);
    data[0].emplomentExtent.push(...municipality_data[idx].emplomentExtent);
    data[0].accommodation.push(...municipality_data[idx].accommodation);
    data[0].livingCondition.push(...municipality_data[idx].livingCondition);
    data[0].taxRate.push(...municipality_data[idx].taxRate);
    data[0].election.push(...municipality_data[idx].election);
  });
  return data;
}

export function getBrowserQueryParams() {
  var qd = { id1: null, id2: null };
  if (window.location.search)
    window.location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        var s = item.split("="),
          k = s[0],
          v = s[1] && decodeURIComponent(s[1]);
        (qd[k] = qd[k] || []).push(v);
      });
  return qd;
}

export function getRequestedMunicipalities() {
  const bp = getBrowserQueryParams();
  let munObj = { "1": null, "2": null };

  if (bp.id1 && bp.id1[0] && hasMunicipalityName(bp.id1[0])) {
    munObj["1"] = {
      id: bp.id1[0],
      name: getMunicipalityName(bp.id1[0])
    };
  }

  if (bp.id2 && bp.id2[0] && hasMunicipalityName(bp.id2[0])) {
    munObj["2"] = {
      id: bp.id2[0],
      name: getMunicipalityName(bp.id2[0])
    };
  }

  return munObj;
}
